import { PropsWithChildren } from 'react';
import { ErrorClass } from './class.tsx';
import { useErrorController } from './controller/index.ts';

export function Error({ children }: PropsWithChildren) {
  const { pathname } = useErrorController();

  return <ErrorClass pathname={pathname}>{children}</ErrorClass>;
}
